// Library Imports
import { createSlice } from "@reduxjs/toolkit";

// Initial State
const initialState = {
  selectedProduct: 0
};

// Selected Content Slice
const selectedContentSlice = createSlice({
  name: "selectedContent",
  initialState,
  reducers: {
    updateProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateProduct } = selectedContentSlice.actions;

export default selectedContentSlice.reducer;
